export const ACTIVITY_REPORTS_LIST = 'ACTIVITY_REPORTS_LIST';
export const ACTIVITY_REPORTS_SUCCESS = 'ACTIVITY_REPORTS_SUCCESS';
export const ACTIVITY_REPORTS_ERROR = 'ACTIVITY_REPORTS_ERROR';


export const ACTIVITY_REPORTS_UPDATE = 'ACTIVITY_REPORTS_UPDATE';
export const ACTIVITY_REPORTS_DETAILS = 'ACTIVITY_REPORTS_UPDATE_DETAILS';
export const ACTIVITY_REPORTS_UPDATE_SUCCESS = 'ACTIVITY_REPORTS_UPDATE_SUCCESS';
export const ACTIVITY_REPORTS_UPDATE_ERROR = 'ACTIVITY_REPORTS_UPDATE_ERROR';